/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const LocationPinBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M6.545 9.271A5.454 5.454 0 0 1 12 3.818a5.454 5.454 0 0 1 5.455 5.454c0 1.619-.775 3.517-1.931 5.465C14.46 16.53 13.14 18.255 12 19.705c-1.14-1.45-2.46-3.176-3.524-4.968-1.156-1.948-1.93-3.846-1.93-5.466ZM12 2a7.272 7.272 0 0 0-7.273 7.271c0 2.125.987 4.375 2.186 6.395 1.213 2.042 2.724 3.979 3.913 5.487l.352.448a1.045 1.045 0 0 0 1.644 0l.352-.448c1.19-1.508 2.7-3.445 3.913-5.487 1.2-2.02 2.186-4.27 2.186-6.395A7.272 7.272 0 0 0 12 2Zm-1.59 7.218a1.59 1.59 0 1 1 3.181 0 1.59 1.59 0 0 1-3.182 0ZM12 5.808a3.41 3.41 0 1 0 0 6.819 3.41 3.41 0 0 0 0-6.818Z" /></svg>);
const LocationPin = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={LocationPinBase} {...rest} ref={ref} />);
export default LocationPin;